import Link from "./Link"
import bricks from "./bricks"
import { navigate } from "gatsby"
import { types } from "react-bricks/frontend"

const config: types.ReactBricksConfig = {
    appId: process.env.REACT_BRICKS_APP_ID,
    apiKey: process.env.REACT_BRICKS_API_KEY,
    pageTypes: [
        {
            name: "page",
            pluralName: "pages",
        },
    ],
    bricks,
    renderLocalLink: Link,
    navigate,
    appRootElement: "#___gatsby",
}

export default config
